import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'

import { AuthService } from '../services/auth.service'
import { Observable } from 'rxjs'
import { ClientContextService } from '@app/core/services/client-context.service'

@Injectable({
  providedIn: 'root',
})
export class IsAuthenticatedGuard {
  constructor(private router: Router, private authService: AuthService, private clientContextService: ClientContextService) {}

  async canActivate(next: ActivatedRouteSnapshot, _snapshot: RouterStateSnapshot) {
    try {
      const user = await this.authService.getUser()
      if (user) {
        return true
      } else {
        // Redirect to appropriate login based on route
        const hasClientContext = next.data['hasClientContext'] as boolean | undefined
        const clientId = next.params['clientId'] as string | undefined

        if (hasClientContext && clientId) {
          this.router.navigate([`/org/${clientId}/auth/login`])
        } else {
          this.router.navigate(['/', 'auth'])
        }
        return false
      }
    } catch (_error) {
      // Check if user was previously in org context
      const isOrgUser = this.clientContextService.isOrgUser()
      const clientId = this.clientContextService.getStoredClientId()

      if (isOrgUser && clientId) {
        this.router.navigate([`/org/${clientId}/auth/login`])
      } else {
        this.router.navigate(['/', 'auth'])
      }
      return false
    }
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state)
  }
}
